import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { CONST_SITE_LABEL, INVENTORY_EVENTS } from '../components/common/Helper';
import {
  CurrentInstanceComponent,
  ScheduledEvents,
  IdleEventsComponent,
  ActivityLogComponent,
  ModificationLogComponent,
} from './EC2Inventory';

const TABS = [
  INVENTORY_EVENTS.INSTANCES,
  INVENTORY_EVENTS.SCHEDULED,
  INVENTORY_EVENTS.IDLE,
  INVENTORY_EVENTS.ACTIVITY,
  INVENTORY_EVENTS.MODIFICATION,
];

export default function RDSInventory() {
  const [selectedTab, setSelectedTab] = useState(INVENTORY_EVENTS.INSTANCES);
  const location = useLocation();

  useEffect(() => {
    document.title = `${CONST_SITE_LABEL} | RDS Inventory`;
  }, [location.pathname]);

  return (
    <div>
      <div className="breadcrumb">
        Inventory <span className="breadcrumb-separator">›</span> <strong>RDS Instance</strong>
      </div>

      <div className="tab-row" style={{ flexWrap: 'wrap', marginBottom: '16px' }}>
        {TABS.map(tab => (
          <div
            key={tab}
            className={`tab${selectedTab === tab ? ' active' : ''}`}
            onClick={() => setSelectedTab(tab)}
          >
            {tab}
          </div>
        ))}
      </div>

      <div>
        {selectedTab === INVENTORY_EVENTS.INSTANCES    && <CurrentInstanceComponent />}
        {selectedTab === INVENTORY_EVENTS.SCHEDULED    && <ScheduledEvents />}
        {selectedTab === INVENTORY_EVENTS.IDLE         && <IdleEventsComponent />}
        {selectedTab === INVENTORY_EVENTS.ACTIVITY     && <ActivityLogComponent />}
        {selectedTab === INVENTORY_EVENTS.MODIFICATION && <ModificationLogComponent />}
      </div>
    </div>
  );
}
